export default __webpack_public_path__ + "static/team_06-2026-f76aa1a76c564f7b1eb1da8e0183a8b4.webp";